var localStorage=window.localStorage?window.localStorage:{lingdi:"true",guozhan:"true",ghls:"true"}
var search={
    serverInfo:null,
    resultData:null,
    checkBoxInfo:null,
    serverName:"",
    init:function(){
        var _this=this;
        $.getJSON("https://hd.tianyu.163.com/rank/getServerInfo.json?callback=?",function(msg){
            _this.serverInfo=msg.data.buckNameServers;
            _this.renderSelect();
            _this.filterResult();
        })
        $(".styled-checkbox").change(function(){
            _this.checkBoxInfo={
                lingdi:$("#styled-checkbox-1").get(0).checked,
                guozhan:$("#styled-checkbox-2").get(0).checked,
                ghls:$("#styled-checkbox-3").get(0).checked
            }
            localStorage.lingdi=_this.checkBoxInfo.lingdi;
            localStorage.guozhan=_this.checkBoxInfo.guozhan;
            localStorage.ghls=_this.checkBoxInfo.ghls;
            _this.filterResult();
        })

    },
    filterResult:function(){
        if(localStorage.lingdi=="true"||localStorage.lingdi==undefined){
            $(".m-lingdi").show();
            $("#styled-checkbox-1").attr("checked",true);
        }else{
            $(".m-lingdi").hide();
            $("#styled-checkbox-1").attr("checked",false);
        }
        if(localStorage.guozhan=="true"||localStorage.guozhan==undefined){
            $(".m-guozhan").show();
            $("#styled-checkbox-2").attr("checked",true);
        }else{
            $(".m-guozhan").hide();
            $("#styled-checkbox-2").attr("checked",false);
        }
        if(localStorage.ghls=="true"||localStorage.ghls==undefined){
            $(".m-ghls").show();
            $("#styled-checkbox-3").attr("checked",true);
        }else{
            $(".m-ghls").hide();
            $("#styled-checkbox-3").attr("checked",false);
        }
    },
    renderSelect:function(){
        var areaList=[];
        for(var i in this.serverInfo){
            areaList.push({name:i,value:i});
        }
        var source=$("#select-template").html();
        var template=Handlebars.compile(source);
        var html=template({items:areaList});
        $(".areaSelect").html(html);
        this.bindEvent();
    },
    bindEvent:function(){
        var _this=this;
        $("body").click(function(){
            $(".select-options").hide();
        })
        $(".select-styled").click(function(e){
            e.stopPropagation();
            $(this).next().show();
        })
        $(".areaSelect").click(function(e){
            var value=$(e.target).attr("data-value");
            $(this).prev().find(".n").html(value);
            _this.changeServerList(value);
            localStorage.area=value;            
            if(($(".serverSelect li[data-value='"+localStorage.server+"']").length>0)){
                $(".serverSelect li[data-value='"+localStorage.server+"']").click();
            }else{
                $(".serverSelect").find("li").eq(0).click();
            }
        })
        $(".serverSelect").click(function(e){
            var value=$(e.target).attr("data-value");
            var txt=$(e.target).html();
            $(this).prev().find(".n").html(txt);
            localStorage.server=value;
            _this.serverName=txt;
            _this.queryResult(value);
        })
        localStorage.area=localStorage.area==undefined?'开天辟地':localStorage.area
        $(".areaSelect li[data-value='"+localStorage.area+"']").click();
    },
    changeServerList:function(areaName){
        var serverObj=this.serverInfo[areaName];
        var serverList=[];
        for(var i in serverObj){
            serverList.push({name:serverObj[i],value:i});
        }
        var source=$("#select-template").html();
        var template=Handlebars.compile(source);
        var html=template({items:serverList});
        $(".serverSelect").html(html);
    },
    queryResult:function(serverId){
        var _this=this;
        $.getJSON("https://hd.tianyu.163.com/yunchuiRank/getYunchuiList.json?callback=?&serverId="+serverId,function(msg){
            _this.resultData=msg.dataMap;
            _this.renderLdz_zl();
            _this.renderLdz_gh();
            _this.renderLdz_gr();         

            gz.render(msg.dataMap.gz);
            ghls.init(msg.dataMap.gh_bh,msg.dataMap.gh_ql);
            _this.setTime($(".m-ghls .time"),msg.dataMap.gh_time);
            _this.setTime($(".m-guozhan .time"),msg.dataMap.gz_time);
            _this.setTime($(".m-lingdi .time"),msg.dataMap.ldz_time);
        })
    },
    setTime:function(el,time){
        if(time==null){
            el.html("");
            return;
        }
        var d=new Date(parseInt(time));
        var y=d.getFullYear();
        var m=(d.getMonth()+1)>9?(d.getMonth()+1):0+""+(d.getMonth()+1);
        var day=d.getDate()>9?d.getDate():0+""+d.getDate();
        el.html(y+"/"+m+"/"+day);
    },
    renderLdz_zl:function(data){
        var data={
            // 西境-岩锤要塞
            ycys:this.getGhFromLdz("岩锤要塞"),
            //西境-火炼窟
            hlk:this.getGhFromLdz("火炼窟"),
            //西境-擎天崖
            qty:this.getGhFromLdz("擎天崖"),
            //西境-落日堡
            lrb:this.getGhFromLdz("落日堡"),
            //中州-祈天神殿
            qtsd:this.getGhFromLdz("祈天神殿"),
            //中州-流霞殿
            lxd:this.getGhFromLdz("流霞殿"),
            //中州--凌霜寨
            lsz:this.getGhFromLdz("凌霜寨"),
            //东洲-东海壁垒
            dhbl:this.getGhFromLdz("东海壁垒"),
            //东洲-望花阁
            whg:this.getGhFromLdz("望花阁"),
            //东洲-墨隐潭
            myt:this.getGhFromLdz("墨隐潭"),
            //东洲-天羽台
            tyt:this.getGhFromLdz("天羽台"),
            //东洲-沧澜宫
            clg:this.getGhFromLdz("沧澜宫")
        }
        var source=$("#ldz_zl-template").html();
        var template=Handlebars.compile(source);
        var html=template(data);
        $(".zhanlin .cnt").html(html);
    },
    renderLdz_gh:function(){
        if(this.resultData.ldz_gh==null){
            $(".shadi .item-1 .noResult").show();
            $(".shadi .item-1 ul").empty();
            return;
        }
        $(".shadi .item-1 .noResult").hide();
        //公会杀敌信息    
        var dataList=[];
        var count=this.resultData.ldz_gh.length>15?15:this.resultData.ldz_gh.length;
        for(var i=0;i<count;i++){
            dataList.push({
                rank:i+1,
                ghName:this.resultData.ldz_gh[i][0],
                join:this.resultData.ldz_gh[i][1],
                kill:this.resultData.ldz_gh[i][2]
            })
        }    
        var source=$("#ldz_gh-template").html();
        var template=Handlebars.compile(source);
        var html=template({items:dataList});
        $(".shadi .item-1 ul").html(html);
    },
    renderLdz_gr:function(data){
        if(this.resultData.ldz_gr==null){
            $(".shadi .item-2 .noResult").show();
            $(".shadi .item-2 ul").empty();
            return;
        }
        $(".shadi .item-2 .noResult").hide();
        //个人杀敌信息
        var dataList=[];
        var count=this.resultData.ldz_gr.length>15?15:this.resultData.ldz_gr.length;
        for(var i=0;i<count;i++){
            dataList.push({
                rank:i+1,
                ghName:this.resultData.ldz_gr[i][0],
                join:this.resultData.ldz_gr[i][1],
                kill:this.resultData.ldz_gr[i][2]
            })
        }
        var source=$("#ldz_gh-template").html();
        var template=Handlebars.compile(source);
        var html=template({items:dataList});
        $(".shadi .item-2 ul").html(html);
    },
    getGhFromLdz:function(name){
        if(this.resultData.ldz_zl==null){
            return {shortName:name,guildName:"未占领"};
        }
        for(var i=0;i<this.resultData.ldz_zl.length;i++){
            if(this.resultData.ldz_zl[i].fortName.indexOf(name)!=-1){
                this.resultData.ldz_zl[i].shortName=name;
                return this.resultData.ldz_zl[i];
            }
        }
        return {shortName:name,guildName:"未占领"};
    }
}

var ghls={
    el:$(".m-ghls"),
    baihuData:null,
    qinglongData:null,
    typeList:[
        [
            {
                a1:"xian",d1:"xian"
            },
            {
                a1:"xian",d1:"xian"
            },
            {
                a1:"shou",d1:"shou"
            },
            {
                a1:"shou",d1:"shou"
            },
            {
                a1:"yu",d1:"yu"
            },
            {
                a1:"yu",d1:"yu"
            }
        ],
        [
            {
                a1:"xian",d1:"xian"
            },
            {
                a1:"xian",d1:"shou"
            },
            {
                a1:"xian",d1:"shou"
            },
            {
                a1:"shou",d1:"yu"
            },
            {
                a1:"shou",d1:"yu"
            }
        ],
        [
            {
                a1:"xian",d1:"xian"
            },
            {
                a1:"xian",d1:"xian"
            },
            {
                a1:"xian",d1:"xian"
            },
            {
                a1:"xian",d1:"xian"
            },
        ]
    ],
    init:function(baihuData,qinglongData){
        this.baihuData=baihuData;
        this.qinglongData=qinglongData;
        var _this=this;
        $(".result").click(function(e){
            var index=$(e.target).index();
            if($(e.target).hasClass("navBtn")){           
                if($(this).index()==1){
                    _this.renderBaihu(index,$(this));
                }else{
                    _this.renderQinglong(index,$(this));
                }
            }            
        })
        this.renderBaihu(0,$(".result-baihu"));
        this.renderQinglong(0,$(".result-qinglong"));
    },
    renderBaihu:function(index,$result){
        $(".result-baihu .serverName").html("【"+search.serverName+"】");
        var dataList;
        if(this.baihuData==null){
            dataList=[];
        }else{
            dataList=this.baihuData[index+1][0]?this.baihuData[index+1][0]:[];
            if(index==2){
                dataList=this.baihuData[3];
            }
        }        
        this.render(dataList,index,$result);
    },
    renderQinglong:function(index,$result){
        $(".result-qinglong .serverName").html("【"+search.serverName+"】");
        var dataList;
        if(this.qinglongData==null){
            dataList=[];
        }else{
            dataList=this.qinglongData[index+1][0]?this.qinglongData[index+1][0]:[];
            if(index==2){
                dataList=this.qinglongData[3];
            }
        }        
        this.render(dataList,index,$result);
    },
    render:function(dataList,index,$result){
        $result.find(".navBtn").removeClass("active");
        $result.find(".navBtn").eq(index).addClass("active");
        if(dataList.length==0){
            $result.find("ul").empty();
            $result.find(".no-result").show();
            return;
        }
        $result.find(".no-result").hide();        
        var renderList=[];
        var length=index==2?4:dataList.length;
        for(var i=0;i<length;i++){
            renderList.push({
                serverName_1:dataList[i][0],
                serverName_2:dataList[i][1],
                result:dataList[i][2],
                a1:this.typeList[index][i].a1,
                d1:this.typeList[index][i].d1
            })
        }
        var source=$("#ghls-template").html();
        var template=Handlebars.compile(source);
        var html=template({items:renderList});
        $result.find("ul").html(html);
    }
}

var gz={
    init:function(){

    },
    render:function(data){
        $(".m-guozhan .score").empty();
        if(data==null){
            $(".m-guozhan .score").html('<h2>国战战绩</h2><p class="time"></p><div class="cnt" style="height:160px;"><p class="t t-1"><span>暂无数据</span></p></div>');
            return;
        } 
        for(var i in data.attackSubScore){
            data["a"+i]=data.attackSubScore[i];
        }
        
        for(var i in data.defendSubScore){
            data["d"+i]=data.defendSubScore[i];
        }
        data.a3+=data.a8;
        data.a4+=data.a7;
        data.d3+=data.d8;
        data.d4+=data.d7;
        var source=$("#gz-template").html();
        var template=Handlebars.compile(source);
        var html=template(data);
        $(".m-guozhan .score").html(html);
    }
}
search.init();
gz.init();

Handlebars.registerHelper('victory', function(index) {
    var result=["defeat","victory"];
    return result[index];
});

Handlebars.registerHelper('defeat', function(index) {
    var result=["victory","defeat"];
    return result[index];
});

Handlebars.registerHelper('vs', function(a,d) {
    if(a==0&&d==0){
        return 50;
    }
    return a/(d+a)*100;
});




//////////////////
// WEBPACK FOOTER
// ./pages/yunchuirank/js/index.js
// module id = 0
// module chunks = 0